import React from 'react';
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { Box, Grid, IconButton } from '@mui/material';
import { formatRoute } from 'react-router-named-routes';
import SearchIcon from '@mui/icons-material/Search';
import Icon from '@mdi/react';
import { mdiPlusCircle } from '@mdi/js';
import {
  END_USER_FIND_ALTERNATIVES_BOARD_ROUTE,
  END_USER_FIND_ALTERNATIVES_MULTI_MENUS_ROUTE,
  END_USER_FIND_ALTERNATIVES_SEARCH_MEALS_ROUTE,
  END_USER_FIND_ALTERNATIVES_WITH_MEAL_DETAIL_ROUTE,
} from '../../services/routes';
import MealBasketWidget from '../../features/end_user_shopping/components/meal_basket_widget';
import PopupTitle from '../common/popup_title';
import EndUserFindAlternativesItem from './end_user_find_alternatives_item';
import { linkWithQueryParams } from '../../services/urls';
import { useAllMultiMenuMeals } from '../common/all_multi_menu_meals_hook';
import {
  useCreateMealMutation,
  useLazyGetFullMealQuery,
  useUpdateMealMutation,
  useUpdateSmorgBoardMutation,
} from '../../app/smorgAppSyncGraphQLApi';
import { customerFoodDataIDOfSpace } from '../../services/spaces';
import {
  myFavouritesRecipesBoard,
  myFavouritesRecipesBoardDefaultMenu,
} from '../../services/smorg_board';
import { newBlankMeal } from '../../services/meals';
import MealDetailContainer from '../meal/meal_detail_container';
import { newMealAddedToRecipesBoard } from '../../operations/recipes_operations';
import { useTracker } from '../../operations/tracking_operations';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetOwnedRecipesBoardsQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const CAROUSEL_LIMIT = 10;

const EndUserFindAlternativesHomePage = () => {
  const navigate = useNavigate();

  const { calendarDay, mealDetailMealID: showDetailForMealID } = useParams();

  const [searchParams] = useSearchParams();

  const mealIDToReplace = searchParams.get('mealId');
  const mealType = searchParams.get('mealType');
  const scrollCookie = searchParams.get('scrollCookie');

  const tracker = useTracker();

  const { data: userProfile } = useGetUserProfileQuery();

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const [createMeal] = useCreateMealMutation();
  const [lazyGetMeal] = useLazyGetFullMealQuery();
  const [updateMeal] = useUpdateMealMutation();
  const [updateSmorgBoard] = useUpdateSmorgBoardMutation();

  const { data: ownedRecipesBoards } = useGetOwnedRecipesBoardsQuery();

  const myFavBoard = myFavouritesRecipesBoard(ownedRecipesBoards);

  const flattenedFavouriteMealIDs = (myFavBoard?.menus || []).flatMap((menu) =>
    (menu.mealIDs || menu.sharedMealIDs).map((mealID) => ({
      mealID,
      menuID: menu.id,
    })),
  );

  const { flattenedSharedBoardsTitleMap } = useAllMultiMenuMeals();

  const onClickResultDetail = (mealID) => {
    navigate(
      linkWithQueryParams(
        formatRoute(END_USER_FIND_ALTERNATIVES_WITH_MEAL_DETAIL_ROUTE, {
          calendarDay,
          mealDetailMealID: mealID,
        }),
        { mealType, mealId: mealIDToReplace },
      ),
    );
  };

  // const onClickGRCResultDetail = (grcRecipeID) => {
  //   navigate(
  //     linkWithQueryParams(
  //       formatRoute(END_USER_FIND_ALTERNATIVES_GRC_RECIPE_ROUTE, {
  //         calendarDay,
  //         grcRecipeId: grcRecipeID,
  //       }),
  //       { mealType, mealId: mealIDToReplace },
  //     ),
  //   );
  // };

  const onDismissDetail = () => {
    navigate(-1);
  };

  // const parentIDInMeals = parentIDOfMealID(
  //   showDetailForMealID,
  //   ownedRecipesBoards,
  // );

  // const {
  //   data: spaceAssignedSharedRecipesBoardsIDs,
  //   error: spaceAssignedSharedRecipesBoardsIDsError,
  //   isLoading: isSaceAssignedSharedRecipesBoardsIDsLoading,
  // } = useGetSpaceAssignedSharedRecipesBoardIDsForEndUserSearchQuery();

  // const {
  //   data: sharedBoards,
  //   error: sharedBoardsError,
  //   isLoading: isSharedBoardsLoading,
  // } = useGetSharedBoardsByIDsQuery(spaceAssignedSharedRecipesBoardsIDs, {
  //   skip:
  //     isSaceAssignedSharedRecipesBoardsIDsLoading ||
  //     !spaceAssignedSharedRecipesBoardsIDs ||
  //     spaceAssignedSharedRecipesBoardsIDs.length === 0,
  //   refetchOnMountOrArgChange: SHARED_BOARDS_REFRESH_INTERVAL_SECONDS,
  // });

  // const allSharedBoardIDs = useMemo(
  //   () => (allSharedBoards || []).map((b) => b.id),
  //   [JSON.stringify(allSharedBoards)],
  // );

  // const parentIDInSharedMeals = parentIDOfSharedMealID(
  //   showDetailForMealID,
  //   allSharedBoards,
  // );

  // const {
  //   data: visibleMealInMeals,
  //   error: visibleMealInMealsError,
  //   isLoading: isVisibleMealInMealsLoading,
  // } = useGetDistilledMealByIDAndParentQuery(
  //   { id: showDetailForMealID, parentID: parentIDInMeals },
  //   { skip: !showDetailForMealID || !parentIDInMeals },
  // );

  // const {
  //   data: sharedMealsByParents,
  //   error: sharedMealsByParentsError,
  //   isLoading: isSharedMealsByParentsLoading,
  // } = useGetDistilledSharedMealsByParentsQuery(allSharedBoardIDs, {
  //   skip: !allSharedBoardIDs || allSharedBoardIDs.length === 0,
  // });

  // const visibleMealInSharedMeals = ((sharedMealsByParents || {})[
  //   parentIDInSharedMeals
  // ] || {})[showDetailForMealID];

  // const visibleMeal =
  //   showDetailForMealID && (visibleMealInMeals || visibleMealInSharedMeals);

  // const alwaysShowNutrition = !isCommunityUser;

  // const {
  //   data: grcRecipeCategories,
  //   error: grcRecipeCategoriesError,
  //   isLoading: isGrcRecipeCategoriesLoading,
  // } = useGetGRCRecipeCategoriesQuery(currentSpaceMembership?.spaceID, {
  //   skip: !currentSpaceMembership?.spaceID,
  // });

  const customerFoodDataID = customerFoodDataIDOfSpace(
    currentSpaceMembership?.spaceID,
  );

  // useEffect(() => {
  //   dispatch(ensureCategoryGRCRecipesLoadedAction());
  // }, [dispatch]);

  const onClickAddMealToFavourites = async () => {
    if (
      !myFavBoard ||
      !myFavouritesMenuID ||
      !userProfile ||
      !currentSpaceMembership
    ) {
      return;
    }
    const newMeal = newBlankMeal();
    await newMealAddedToRecipesBoard(
      myFavBoard,
      myFavouritesMenuID,
      newMeal,
      0,
      customerFoodDataID,
      tracker,
      userProfile,
      currentSpaceMembership,
      null,
      createMeal,
      updateSmorgBoard,
      updateMeal,
      lazyGetMeal,
      (insertedMeal) => {
        navigate(
          linkWithQueryParams(
            formatRoute(END_USER_FIND_ALTERNATIVES_WITH_MEAL_DETAIL_ROUTE, {
              calendarDay,
              mealDetailMealID: insertedMeal.id,
            }),
            { mealType, mealId: mealIDToReplace },
          ),
        );
      },
    );
  };

  const myFavouritesMenuID =
    myFavouritesRecipesBoardDefaultMenu(ownedRecipesBoards)?.id;

  if (showDetailForMealID) {
    return (
      <MealDetailContainer
        parentSmorgBoardId={myFavBoard.id}
        mealId={showDetailForMealID}
        menuId={myFavouritesMenuID}
        visible
        dismiss={onDismissDetail}
      />
    );
  }
  return (
    <div className="recipes-search">
      <div style={{ color: 'var(--app-primary-font-color)' }}>
        <PopupTitle
          titleText="Search for a meal"
          backButtonEnabled
          onClickBack={() => navigate(-1)}
        />
      </div>
      <MealBasketWidget />
      <div
        style={{
          marginTop: '20px',
        }}>
        <Grid container>
          <Grid
            item
            xs={12}
            onClick={() =>
              navigate(
                linkWithQueryParams(
                  formatRoute(END_USER_FIND_ALTERNATIVES_SEARCH_MEALS_ROUTE, {
                    calendarDay,
                  }),
                  { mealType, mealId: mealIDToReplace, scrollCookie },
                ),
              )
            }
            style={{
              padding: '12px',
              paddingLeft: '12px !important',
              textAlign: 'left',
              fontSize: '14px',
              color: 'var(--app-primary-font-color)',
              opacity: 0.5,
              border: '1px solid',
              borderRadius: '8px',
              margin: '8px 16px',
              cursor: 'pointer',
              display: 'flex',
            }}>
            <SearchIcon style={{ margin: 'auto 0' }} />
            <span style={{ paddingTop: '2px' }}>Search recipes</span>
          </Grid>
        </Grid>
        {myFavBoard && flattenedFavouriteMealIDs.length > 0 && (
          <>
            <Grid container>
              <Grid item xs={8}>
                <h2
                  style={{
                    margin: '23px 23px 5px',
                    color: 'var(--app-primary-font-color)',
                    textAlign: 'left',
                  }}>
                  {myFavBoard.title}
                </h2>
              </Grid>
              <Grid
                item
                xs={4}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}>
                <Box
                  sx={{
                    margin: 'auto 10px 7px',
                    color: 'var(--app-primary-font-color)',
                  }}>
                  <Link
                    to={linkWithQueryParams(
                      formatRoute(END_USER_FIND_ALTERNATIVES_BOARD_ROUTE, {
                        calendarDay,
                        recipesBoardId: myFavBoard.id,
                      }),
                      { mealType, mealId: mealIDToReplace },
                    )}>
                    View all
                  </Link>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
              <div
                style={{
                  margin: '10px 23px',
                  cursor: 'pointer',
                  fontWeight: 800,
                  display: 'flex',
                }}
                onClick={onClickAddMealToFavourites}>
                <IconButton
                  aria-label="add"
                  size="small"
                  style={{ padding: 0 }}>
                  <Icon
                    path={mdiPlusCircle}
                    style={{
                      width: '24px',
                      height: '24px',
                      color: 'var(--app-primary-font-color)',
                      marginRight: '8px',
                    }}
                  />
                </IconButton>
                <div
                  style={{
                    margin: 'auto 0',
                    fontSize: '14px',
                    color: 'var(--app-primary-font-color)',
                  }}>
                  Create new recipe
                </div>
              </div>
            </Grid>

            {flattenedFavouriteMealIDs.length > 0 && (
              <div style={{ overflowX: 'auto', display: 'flex' }}>
                {flattenedFavouriteMealIDs
                  .slice(0, CAROUSEL_LIMIT)
                  .map(({ mealID }) => (
                    <div key={mealID} style={{ flexShrink: 0 }}>
                      <EndUserFindAlternativesItem
                        mealID={mealID}
                        calendarDay={calendarDay}
                        mealType={mealType}
                        mealIDToReplace={mealIDToReplace}
                        onClick={onClickResultDetail}
                      />
                    </div>
                  ))}
              </div>
            )}
          </>
        )}
        {Object.values(flattenedSharedBoardsTitleMap).map(
          ({ menus, menuTitle }) => {
            if (!menus || menus.length === 0) {
              return null;
            }
            const searchParamsArgs = {
              mealType,
              mealId: mealIDToReplace,
              menuIDs: menus.map((m) => m.menuID),
              parentIDs: menus.map((m) => m.parentID),
            };
            return (
              <>
                <Grid container>
                  <Grid item xs={8}>
                    <h2
                      style={{
                        margin: '23px 23px 5px',
                        color: 'var(--app-primary-font-color)',
                        textAlign: 'left',
                      }}>
                      {menuTitle}
                    </h2>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}>
                    <Box
                      sx={{
                        margin: 'auto 10px 7px',
                        color: 'var(--app-primary-font-color)',
                      }}>
                      <Link
                        to={linkWithQueryParams(
                          formatRoute(
                            END_USER_FIND_ALTERNATIVES_MULTI_MENUS_ROUTE,
                            {
                              calendarDay,
                            },
                          ),
                          searchParamsArgs,
                        )}>
                        View all
                      </Link>
                    </Box>
                  </Grid>
                </Grid>

                <div style={{ overflowX: 'auto', display: 'flex' }}>
                  {menus.flatMap((menu) =>
                    (menu.mealIDs || menu.sharedMealIDs)
                      .slice(0, CAROUSEL_LIMIT)
                      .map((mealID) => (
                        <div key={mealID} style={{ flexShrink: 0 }}>
                          <EndUserFindAlternativesItem
                            mealID={mealID}
                            calendarDay={calendarDay}
                            mealType={mealType}
                            mealIDToReplace={mealIDToReplace}
                            onClick={onClickResultDetail}
                          />
                        </div>
                      )),
                  )}
                </div>
              </>
            );
          },
        )}
        {/* (grcRecipeCategories || []).map((category) => {
          const searchParamsArgs = {
            mealType,
            mealId: mealIDToReplace,
          };
          return (
            <>
              <Grid container>
                <Grid item xs={8}>
                  <h2
                    style={{
                      margin: '23px 23px 5px',
                      color: 'var(--app-primary-font-color)',
                      textAlign: 'left',
                    }}>
                    {category.title}
                  </h2>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}>
                  <Box
                    sx={{
                      margin: 'auto 10px 7px',
                      color: 'var(--app-primary-font-color)',
                    }}>
                    <Link
                      to={linkWithQueryParams(
                        formatRoute(
                          END_USER_FIND_ALTERNATIVES_GRC_RECIPE_CATEGORY_ROUTE,
                          {
                            calendarDay,
                            categoryID: category.id,
                          },
                        ),
                        searchParamsArgs,
                      )}>
                      View all
                    </Link>
                  </Box>
                </Grid>
              </Grid>

              <div style={{ overflowX: 'auto', display: 'flex' }}>
                {(category?.result?.data || []).map((item) => (
                  <EndUserFindAlternativesGRCRecipeItem
                    key={item.grcRecipeID}
                    calendarDay={calendarDay}
                    grcRecipeID={item.grcRecipeID}
                    mealType={mealType}
                    mealIDToReplace={mealIDToReplace}
                    onClick={onClickGRCResultDetail}
                  />
                ))}
              </div>
            </>
          );
        }) */}
      </div>
    </div>
  );
};

export default EndUserFindAlternativesHomePage;
